import { render, staticRenderFns } from "./appHorizontalScroll.vue?vue&type=template&id=5c6d9066&scoped=true"
import script from "./appHorizontalScroll.vue?vue&type=script&lang=js"
export * from "./appHorizontalScroll.vue?vue&type=script&lang=js"
import style0 from "./appHorizontalScroll.vue?vue&type=style&index=0&id=5c6d9066&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c6d9066",
  null
  
)

export default component.exports